import React from 'react';
import classnames from 'classnames';
import ListRenderGuide from '@gp/components/ListRenderGuide';
import ReportWallpaper from '../../../components/ReportWallpaper';
import Comment from '../Comment';
import Hightlights from '../Hightlights/components/Panel';
import Changes from '../Changes/ReviewChanges';
import Miscellaneous from '../Miscellaneous/ReviewMiscellaneous';
import Calendar from '../Calendar/ReviewCalendar';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportCalendarDTO } from '@gp/types/dpsReport/common';
import type {
  IDPSReportVOV2,
  IDPSReportChangeDTO,
  IDPSReportHightlightDTO,
  IDPSReportOtherOrMiscellaneousDTO,
} from '@gp/types/dpsReport/v2';

import './index.scss';

interface IReviewEditableReportProps extends IBaseProps {
  node?: React.RefObject<HTMLDivElement>;
  dateTitle?: string;
  report?: IDPSReportVOV2 | null;
}

const ReviewEditableReport: React.FC<IReviewEditableReportProps> = (props) => {
  const { style, className, node, dateTitle, report } = props;

  const {
    comment,
    hightlights,
    changes,
    miscellaneous,
    calendar,
    start_date_dps_report_week: startDate,
    end_date_dps_report_week: endDate,
  } = report || {};

  return (
    <ReportWallpaper
      ref={node}
      style={style}
      className={classnames('dbg-dps-report__review-editable-report', className)}
      dateTitle={dateTitle}
    >
      {comment && <Comment readonly value={comment} />}
      <ListRenderGuide list={hightlights}>
        <Hightlights startDate={startDate} endDate={endDate} data={hightlights as IDPSReportHightlightDTO[]} />
      </ListRenderGuide>
      <ListRenderGuide list={changes}>
        <Changes value={changes as IDPSReportChangeDTO[]} />
      </ListRenderGuide>
      <ListRenderGuide list={miscellaneous}>
        <Miscellaneous value={miscellaneous as IDPSReportOtherOrMiscellaneousDTO[]} />
      </ListRenderGuide>
      <ListRenderGuide list={calendar}>
        <Calendar date={endDate} value={calendar as IDPSReportCalendarDTO[]} />
      </ListRenderGuide>
    </ReportWallpaper>
  );
};

export default ReviewEditableReport;
